var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"justify-center grid-list"},_vm._l((_vm.items),function(item,keyItems){return _c('TeamCard',_vm._b({key:keyItems},'TeamCard',item,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }